import { render, staticRenderFns } from "./SupplierSeverityChart.vue?vue&type=template&id=b04a45f4&"
import script from "./SupplierSeverityChart.vue?vue&type=script&lang=ts&"
export * from "./SupplierSeverityChart.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports